import React from "react";

import { Box } from "@mui/material";

import { Paragraph, SubtitleStyles } from "../../types";
import SubtitleModeSwitcher from "./components/SubtitleModeSwitcher";
import StyleEditor from "./components/StyleEditor";
import SubtitlesEditor from "./components/SubtitlesEditor";

interface SubtitleProps {
  styles: SubtitleStyles;
  paragraphs: Paragraph[];
  onUpdateStyles: (styles: SubtitleStyles, paragraph?: Paragraph) => void;
  onUpdateParagraph: (paragraph: Paragraph) => void;
  currentTimeInMilliseconds: number;
  onParagraphClick: (ms: number) => void;
}

export default function Subtitle({
  styles,
  paragraphs,
  onUpdateStyles,
  onUpdateParagraph,
  currentTimeInMilliseconds,
  onParagraphClick,
}: SubtitleProps) {
  const [selectedTab, setSelectedTab] = React.useState(0);

  return (
    <Box
      sx={{
        background: "#fff",
        borderRadius: "18px",
        boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
        p: 3,
        width: "100%",
        m: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <SubtitleModeSwitcher
        selectedTab={selectedTab}
        onSelectTab={setSelectedTab}
      />
      <Box
        sx={{
          overflowY: "auto",
          background: "#fff",
          borderRadius: "12px",
          p: 2,
          minHeight: 400,
          maxHeight: 570,
        }}
      >
        {selectedTab === 0 && (
          <StyleEditor styles={styles} onUpdateStyles={onUpdateStyles} />
        )}

        {selectedTab === 1 && (
          <SubtitlesEditor
            paragraphs={paragraphs}
            onUpdateParagraph={onUpdateParagraph}
            currentTimeInMilliseconds={currentTimeInMilliseconds}
            onParagraphClick={(paragraph) =>
              // add 1 ms to fix the issue with selecting two paragraphs
              onParagraphClick(paragraph.start * 1000 + 1)
            }
          />
        )}
      </Box>
    </Box>
  );
}
